// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@assets/rank/recap_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@assets/rank/season_recap_singleBG.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@assets/rank/active_rankno.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@assets/rank/share_btn_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.season-card-container {
    font-family: 'Kim';
}

.season-card-header {
    margin-right: 6px;
    margin-left: 40px;
    padding: 6px 0;
    padding-left: 80px;
    background-color: #252b36;
    border: 1px solid #274c57;
    border-radius: 4px;
    position: relative;
}

.season-card-header .categoryBtn { 
    position: absolute; 
    top: 4px; 
    right: 4px;
}


.season-card-header-img {
    position: absolute;
    top: calc(50% - 20px);
    left: 12px;
    height: 54px; 
    width: 54px;
}

.season-card-header-img>img {
    width: 100%;
    height: auto;
}

.season-card-header-title {
    color: white;
}

.season-card-header-title>span:first-child {
    color: #ffa600;
}

.season-card-body {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    padding: 8px;
    padding-bottom: 14px;
    margin-left: 36px;
}

.recap-single-container {
    display: flex;
    gap: 2px;
    align-items: center;
    justify-content: center;
}

.season-recap {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    padding: 12px;
    min-width: 92px;
    min-height: 106px;
    height: 82%;
    position: relative;
}

.season-recap-title {
    font-size: 14px;
    color: #ffa600;
}

.season-recap-label {
    font-size: 14px;
    color: #FFFFFF;
}

.season-recap-img {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: 100% 100%;
    width: 64px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 4px;
}

.season-recap-img span {
    font-size: 14px;
    color: #FFFFFF;
}

.recap-season-bg {
    /* position: absolute; */
    /* bottom: 20px; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 4px 8px;
    margin-left: -1px;
}

.recap-season-bg img {
    width: 56px;
    height: 30px;
}

.season-share-button {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2px;
    height: 36px;
    padding: 2px 6px;
    margin-right: 6px;
    cursor: pointer;
}

.season-share-button img {
    width: 24px;
    height: 22px;
}

.season-share-button span {
    font-size: 8px;
    color: #ffa600;
}

.recap-season-timer-label {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
}

.recap-season-timer-label span {
    font-size: 12px;
    color: #ffa600;
}

.recap-season-timer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    color: #FFFFFF;
}

.recap-season-timer span {
    font-size: 12px;
}

.season-timer-icon { 
    margin-top: 4px;
    width: 16px;
    height: 16px;
    /* position: absolute;
    bottom: 12px; */
}`, "",{"version":3,"sources":["webpack://./src/components/seasonCard/SeasonCard.style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;;AAGA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mDAA4C;IAC5C,0BAA0B;IAC1B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mDAAyD;IACzD,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mDAAiD;IACjD,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mDAAgD;IAChD,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ;mBACe;AACnB","sourcesContent":[".season-card-container {\n    font-family: 'Kim';\n}\n\n.season-card-header {\n    margin-right: 6px;\n    margin-left: 40px;\n    padding: 6px 0;\n    padding-left: 80px;\n    background-color: #252b36;\n    border: 1px solid #274c57;\n    border-radius: 4px;\n    position: relative;\n}\n\n.season-card-header .categoryBtn { \n    position: absolute; \n    top: 4px; \n    right: 4px;\n}\n\n\n.season-card-header-img {\n    position: absolute;\n    top: calc(50% - 20px);\n    left: 12px;\n    height: 54px; \n    width: 54px;\n}\n\n.season-card-header-img>img {\n    width: 100%;\n    height: auto;\n}\n\n.season-card-header-title {\n    color: white;\n}\n\n.season-card-header-title>span:first-child {\n    color: #ffa600;\n}\n\n.season-card-body {\n    background: url('@assets/rank/recap_bg.png');\n    background-size: 100% 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n    padding: 8px;\n    padding-bottom: 14px;\n    margin-left: 36px;\n}\n\n.recap-single-container {\n    display: flex;\n    gap: 2px;\n    align-items: center;\n    justify-content: center;\n}\n\n.season-recap {\n    background: url('@assets/rank/season_recap_singleBG.png');\n    background-size: 100% 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 2px;\n    padding: 12px;\n    min-width: 92px;\n    min-height: 106px;\n    height: 82%;\n    position: relative;\n}\n\n.season-recap-title {\n    font-size: 14px;\n    color: #ffa600;\n}\n\n.season-recap-label {\n    font-size: 14px;\n    color: #FFFFFF;\n}\n\n.season-recap-img {\n    background: url('@assets/rank/active_rankno.png');\n    background-size: 100% 100%;\n    width: 64px;\n    height: 64px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 4px;\n}\n\n.season-recap-img span {\n    font-size: 14px;\n    color: #FFFFFF;\n}\n\n.recap-season-bg {\n    /* position: absolute; */\n    /* bottom: 20px; */\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 4px 8px;\n    margin-left: -1px;\n}\n\n.recap-season-bg img {\n    width: 56px;\n    height: 30px;\n}\n\n.season-share-button {\n    background: url('@assets/rank/share_btn_bg.png');\n    background-size: 100% 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 2px;\n    height: 36px;\n    padding: 2px 6px;\n    margin-right: 6px;\n    cursor: pointer;\n}\n\n.season-share-button img {\n    width: 24px;\n    height: 22px;\n}\n\n.season-share-button span {\n    font-size: 8px;\n    color: #ffa600;\n}\n\n.recap-season-timer-label {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    width: 100%;\n}\n\n.recap-season-timer-label span {\n    font-size: 12px;\n    color: #ffa600;\n}\n\n.recap-season-timer {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    width: 100%;\n    color: #FFFFFF;\n}\n\n.recap-season-timer span {\n    font-size: 12px;\n}\n\n.season-timer-icon { \n    margin-top: 4px;\n    width: 16px;\n    height: 16px;\n    /* position: absolute;\n    bottom: 12px; */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
